import {Controller} from "@hotwired/stimulus";
import axios from "axios";

export default class extends Controller {
    static targets = ["noCards"];

    timer = null;

    connect() {
        this.cards = document.querySelectorAll(".accordion-item");
        this.searchInput = document.getElementById('searchBox');
        this.searchInput.addEventListener('keyup', this.handleSearch.bind(this));
    }

    handleSearch(e) {
        if (this.timer) {
            clearTimeout(this.timer);
        }

        this.timer = setTimeout(() => {
            const csrfToken = document.querySelector('[name="_csrf_token"]').value;
            axios({
                method: 'get',
                url: '/faq',
                headers: {
                    'X-CSRF-TOKEN': csrfToken
                }
            });
            this.timer = null;
        }, 1000);

        const searchQuery = e.target.value.toLowerCase();
        const locale = window.location.pathname.split("/")[1].toUpperCase();
        gtag("event", "search", {
          site_language: locale.length > 2 ? "EN" : locale,
            place: "faq",
            search_term: searchQuery
        });
      if (typeof rdt === "function") {
        rdt("track", "Custom", { customEventName: "search" });
      }

        for (let i = 0; i < this.cards.length; i++) {
            if (this.cards[i].textContent.toLowerCase().includes(searchQuery)) {
                this.cards[i].classList.remove("is-hidden");
            } else {
                this.cards[i].classList.add("is-hidden");
            }
        }

        const hiddenCards = document.querySelectorAll(".accordion-item.is-hidden");

        if (hiddenCards.length === this.cards.length) {
            this.noCardsTarget.classList.remove("d-none");
        } else {
            this.noCardsTarget.classList.add("d-none");
        }
    }
    gtagClick(e) {
        const locale = window.location.pathname.split("/")[1].toUpperCase();
        gtag("event", "navigation_click", {
          site_language: locale.length > 2 || !locale ? "EN" : locale,
            place: "faq",
            menu_block: e.params.label
        });
      if (typeof rdt === "function") {
        rdt("track", "Custom", { customEventName: "navigation_click" });
      }
    }

}